/*
  COPYRIGHT NOTICE
  All code within this file is the copyrighted intellectual property of Personal Prints and cannot be duplicated without consent.


  global
  json_product
  shopify_cdn_url_template
  shopify_theme_tags
*/
/**
 * Personalizer app module.
 *
 * @param {Object} product Shopify product as javascript object
 * @param {Array} themeTags List of theme tag strings
 * @param {String} shopifyFileUrl A complete
 * @returns {Object} Personalizer module
 */
var PersonalPrintsPersonalizer = (function(product, themeTags, shopifyFileUrl) {
  /* eslint-disable no-unused-vars */
  var init,
    productTheme,
    newNamingConvention,
    cdnFileUrl,
    findThemePrefix,
    imagesRetriever,
    ImagesRetriever,
    LetterImage,
    LetterPicker,
    LetterSize,
    BackgroundImage,
    BackgroundPicker,
    Personalizer,
    PersonalizerUI;
  /* eslint-enable no-unused-vars */

  /**
   * Finds theme prefix for current product.
   *
   * @return {String} theme prefix
   */
  findThemePrefix = function() {
    var tags = product.tags
    // Convert to array if receiving as string
    if (typeof tags == 'string') {
      tags = tags.split(', ');
    }
    for (var i = 0; i < tags.length; i++) {
      if (~tags[i].indexOf('prefix_')) {
        return tags[i].replace('prefix_', '');
      }
    }
  }

  /**
   * Finds theme prefix for current product.
   *
   * @return {String} theme prefix
   */
  findNamingConvention = function() {
    var tags = product.tags
    // Convert to array if receiving as string
    if (typeof tags == 'string') {
      tags = tags.split(', ');
    }
    for (var i = 0; i < tags.length; i++) {
      if (~tags[i].indexOf('naming')) {
        return tags[i].replace('prefix_', '');
      }
    }
    return false;
  }

  /**
   * Replace file name in shopifyFileUrl, leaving query string in place for cache-busting.
   *
   * @param {String} filename file basename + dot-extension, e.g., 'CO_BG_940x.jpg'
   * @return {String} file url in Shopify cdn.
   */
  cdnFileUrl = function(filename) {
    return shopifyFileUrl.replace(/[^\/]+(\?.*)$/, filename + '$1')
  }

  /*
    global
    BackgroundImage
    LetterImage
    themeTags
  */
  /* eslint-disable-next-line */
  ImagesRetriever = (function() {

    function ImagesRetriever() {
      this.images = [];
      this._cache = {};
      this._limits = {};
    }

    // Retrieves all images for a given letter or background. When theme is given, only retrieves for given theme.
    // @param options [Object] callback: [Function] executed with each successfully retrieved letter image
    //                         letter: [String] letter, e.g. A
    //                         theme: [Object] product theme object (optional)
    //                         batchSize: [Number] (optional, default: 3)
    // @return [Deferred] jQuery.when deferred grouping all batch requests.
    ImagesRetriever.prototype.retrieveImages = function(type, options) {
      var batch, batchSize, batches, key, optionsPerTheme;
      batches  = [];
      batch     = 0;
      batchSize = options.batchSize || 3;
      this._deferred = $.Deferred();
      if (options.theme) {
        return this.retrieveBatch(type, batch, batchSize, options);
      }
      for (key in themeTags) {
        optionsPerTheme = {
          theme: themeTags[key],
          letter: options.letter,
          callback: options.callback
        };
        console.debug('optionsPerTheme', optionsPerTheme);
        batches.push(this.retrieveBatch(type, batch, batchSize, optionsPerTheme));
      }
      return $.when.apply(this, batches);
    }

    // Asynchronously retrieves batch of images from Shopify CDN. If all images in batch are found
    // in CDN, recursively calls itself to retrieve next batch, with the returned Promise being for
    // that next batch.
    //
    // @param type [String] letter or background
    // @param batch [Number]
    // @param batchSize [Number]
    // @param options [Object] options to pass down to retrieveLetterImage method or LetterImage constructor.
    // @return [Deferred] jQuery deferred object with all requests for batch.
    ImagesRetriever.prototype.retrieveBatch = function(type, batch, batchSize, options) {
      var _this, requests, number, max, image, request;
      _this = this;
      requests = [];

      for (number = batch * batchSize + 1, max = number + batchSize; number < max; number++) {
        options.number = number;
        console.debug('retrieveBatch options', options);
        image = (type === 'background') ? new BackgroundImage(options) : new LetterImage(options);
        if (number > 1 && this._outOfBounds(image)) {
          continue;
        }
        request = (type === 'background') ? this.retrieveBackgroundImage(options) : this.retrieveLetterImage(options);
        requests.push(request);
      }
      if (!requests.length) {
        console.debug('no requests for batch', batch);
        return $.when();
      }
      return $.when.apply(this, requests)
        .then(function() {
          // Since all image requests for this letter were successful, recursively request more.
          console.debug("recursively request more images", batch + 1, batchSize, options);
          return _this.retrieveBatch(type, batch + 1, batchSize, options);
        }, function() {
          // Neutralize failure with a resolved promise so upstream promise knows when all requests have finished.
          return $.when();
        })
    }

    // Retrieves a single image asynchronously. Callback either caches retrieved image or sets
    // boundary for failed request to avoid repeated failures.
    // @param options [Object] options to pass down to LetterImage constructor.
    // @return [Deferred] jQuery deferred object for ajax request.
    ImagesRetriever.prototype.retrieveLetterImage = function(options) {
      var _this, letterImage, letterImageCached, promise, url, dimensions, width, letterSize, proportionalDimension;
      _this = this;
      letterImage = new LetterImage(options);
      letterImageCached = this._cache[letterImage.basename];
      if (letterImageCached) {
        letterImage = letterImageCached;
        console.debug('empty promise due to cached image', letterImage.basename);
        promise = $.when();
      } else {
        dimensions = '_100x';
        url = letterImage.setSrc(dimensions);
        console.debug('letterImage', letterImage, 'url', url);
        promise = $.get(url);
      }
      return promise
        .then(function() {
          if (!letterImageCached) {
            _this._cacheImage(letterImage);
          }
          return letterImage;
        },
        function() {
          _this._setImageBoundary(letterImage);
        })
        .done(options.callback);
    }

    // Retrieves a single background image asynchronously. Callback either caches retrieved image
    // or sets boundary for failed request to avoid repeated failures.
    // @param options [Object] options to pass down to LetterImage constructor.
    // @return [Deferred] jQuery deferred object for ajax request.
    ImagesRetriever.prototype.retrieveBackgroundImage = function(options) {
      var _this, backgroundImage, backgroundImageCached, promise, url;
      _this = this;
      backgroundImage = new BackgroundImage(options);
      backgroundImageCached = this._cache[backgroundImage.basename];
      if (backgroundImageCached) {
        backgroundImage = backgroundImageCached;
        console.debug('empty promise due to cached image', backgroundImage.basename);
        promise = $.when();
      } else {
        url = backgroundImage.toString();
        console.debug('backgroundImage', backgroundImage, 'url', url);
        promise = $.get(url);
      }
      return promise
        .then(function() {
          if (!backgroundImageCached) {
            _this._cacheImage(backgroundImage);
          }
          return backgroundImage;
        },
        function() {
          _this._setImageBoundary(backgroundImage);
        })
        .done(options.callback);
    }

    ImagesRetriever.prototype._cacheImage = function(image) {
      this.images.push(image);
      this._cache[image.basename] = image;
    }

    // Sets boundary number for given image, i.e., lowest number image not found on server.
    // @param image [LetterImage|BackgroundImage]
    ImagesRetriever.prototype._setImageBoundary = function(image) {
      var imageBoundary, key;
      key = image.prefix;
      imageBoundary = this._limits[key];
      if (!imageBoundary || imageBoundary > image.number) {
        imageBoundary = this._limits[key] = image.number;
      }
      return imageBoundary;
  }

    // Checks if given image number is same or higher than limit for theme letter.
    // @param image [LetterImage|BackgroundImage]
    ImagesRetriever.prototype._outOfBounds = function(image) {
      return (this._limits[image.prefix] &&
          image.number >= this._limits[image.prefix]);
    }

    return ImagesRetriever
  })();


  /*
    global
    LetterSize
    LetterImage
  */
  /* eslint-disable-next-line  */
  Personalizer = (function() {

    // Constructor
    // @options string [String] string to personalize.
    // @options theme [Object] theme to personalize from.
    // @options form [HTMLFormElement] form html element where properties fields will be added.
    function Personalizer(options) {
      this.form = options.form;
      this.theme = options.theme;
      this.string = this.constructor.cleanInput(options.string);
      this.letters = this.string.split('');
      this.images = this.getDefaultImages();
      this.letterSize = new LetterSize({ charLength: this.letters.length });
      this.lettersContainer = options.lettersContainer || $('#personalizer_letters');
      this.backgroundContainer = options.backgroundContainer || $('#personalizer_bg_img');

      // Set the background image.
      var initialBackground = new BackgroundImage({ theme: productTheme });
      this.backgroundContainer.empty()
      .append('<img src="' + initialBackground + '" alt="">')
      .data('backgroundImage', initialBackground);



      // this.regex = /([^A-z\u2665\u2661\s]|_)/gi
      console.debug(this.theme, this.string, this.letters, this.images, this.letterSize, this.backgroundContainer, this);
      console.debug('getDefaultImages', this.getDefaultImages())
    }

    // Cleans non-letter characters and makes all uppercase.
    // TODO: allow for unicode heart character.
    // @return [String] uppercase string.
    Personalizer.cleanInput = function(string) {
      return string.replace(/([^A-z\u2665\u2661\s]|_)/gi, '').toUpperCase();
    }

    // Tests to see if the string contains forbidden characters
    // @param [String]
    // @return [Boolean]
    Personalizer.containsNumbers = function(string) {
      var regex = /([^A-z\u2665\u2661\s]|_)/gi
      return regex.test(string);
    }

    // Checks letter to see if it's a space or a heart
    // TODO: Maybe rename this function
    // @param [String] - individual letter or unicode character
    // @return [String] - individual letter or 'HEART' || 'SPACE'
    Personalizer.prototype.parseSpecialCharacters = function(letter) {
      var heartRegex = /(\u2661|\u2665)/
      if (heartRegex.test(letter)) return 'HEART';
      if (letter === ' ') return 'SPACE';

      return letter;
    }

    // Default (first) images from this theme for each letter entered by user.
    // It will use different images for repeated letters, e.g., 'AAA' becomes images A_1, A_2, A_3
    // TODO: Always set number: 1 for special characters.
    // @return [Array<LetterImage>] letter images
    Personalizer.prototype.getDefaultImages = function() {
      var letter, letterHash;
      letterHash = {};
      return this.letters.map(function(letter) {
        letter = this.parseSpecialCharacters(letter);
        letterHash[letter] = 1 + (letterHash[letter] || 0);
        return new LetterImage({ theme: this.theme, letter: letter, number: letterHash[letter] });
      }, this);
    }

    // Creates properties[] hidden input fields for every letter, after clearing out any existing.
    Personalizer.prototype.createLineItemProperties = function() {
      var elements;
      this.clearLineItemProperties();
      Personalizer.createLineItemProperty('Text', this.string).appendTo(this.form);
      elements = this.images.map(function(image, i) {
        return Personalizer.createLineItemProperty('Character ' + (i+1), image.basename)
      });
      elements.push()
      $(this.form).append(elements);
      Personalizer.createLineItemProperty('Background', this.backgroundContainer.data('backgroundImage').basename)
        .appendTo(this.form);
    }

    // Creates properties[] hidden input field element with given key and value.
    // @param key [String] key for properties form element.
    // @param value [String] value for properties[key] form element.
    // @return [jQuery] containing a single HTMLInputElement.
    Personalizer.createLineItemProperty = function(key, value) {
      return $('<input type="hidden">').attr({
        name: 'properties[' + key + ']',
        value: value
      });
    }

    // Clear existing line item properties[character-*] input fields.
    Personalizer.prototype.clearLineItemProperties = function() {
      $('input[name^="properties"]', this.form).filter(function() {
        return /\[(Text|Background|Character \d+)\]/.test(this.name);
      }).remove();
    }

    // Overlays letters on background element by placing them into given container.
    //  For each image, a deferred is created, then marked as resolved when the image is detected
    //  have loaded. When all images have loaded, the spinner is removed.
    //  When an image fails to load and its number is > 1, recreate the LetterImage object with
    //  number set to 1 to load the default image again.
    //
    // @param lettersContainer [HTMLElement,jQuery] element to contain letter images.
    Personalizer.prototype.overlayLetters = function(lettersContainer) {
      var _this, measurements, deferreds;
      $('#personalizer_controls').hide();
      $(lettersContainer).show();
      $('.letter_image', lettersContainer).remove();
      _this = this;
      measurements = this.getMeasurements();
      deferreds = [];

      this.insertSpinner();
      this.images.forEach(function(letterImage, i) {
        var $img, $letterImageContainer;
        letterImage.setSrc(measurements.dimensions);
        $letterImageContainer = $(letterImage.buildHtml())
          .appendTo(lettersContainer)
          .data({ letterImage: letterImage, index: i })
          .css('padding', measurements.padding)

        $img = $letterImageContainer.children('img')
        if (letterImage.letter === 'SPACE') {
          $letterImageContainer
            .css('width', measurements.spaceWidth)
        } else {
          deferreds[i] = $.Deferred();
          $img.attr('data-size', measurements.dimensions);
          if ($img[0].complete) {
            deferreds[i].resolve();
          } else {
            $img.on('load', deferreds[i].resolve);
          }
        }

        if (letterImage.number > 1) {
          $img.on('error', function() {
            var options = $.extend(letterImage.getOptions(), { number: 1 });
            letterImage = new LetterImage(options);
            letterImage.setSrc(measurements.dimensions);
            $img[0].src = letterImage.src;
            $img.off('error');
            _this.images[i] = letterImage;
            _this.createLineItemProperties();
          });
        }
      });
      $.when.apply(null, deferreds).done(function() {
        _this.removeSpinner()
      });
    }

    // Replaces letter image in given slot, updating references to active letter image in
    // this.images and in letters container data.
    // @param options [Object] letterImage: [LetterImage] letter image to clone and replace.
    //                         index: [Number] 0-based index of image to replace.
    // @return [jQuery] img element in personalizer preview, with new src.
    Personalizer.prototype.replaceImage = function(options) {
      var $img, $lettersContainer, $slot, index, newLetterImage;
      index = options.index;
      $lettersContainer = this.lettersContainer;
      $slot = $lettersContainer.find('.letter_image').eq(index);
      newLetterImage = options.letterImage.clone();

      this.images[index] = newLetterImage;
      $lettersContainer.data('activeLetterImage', newLetterImage);
      $slot.data('letterImage', newLetterImage);
      newLetterImage.setSrc(this.getMeasurements().dimensions);
      $img = $slot.find('img').attr('src', newLetterImage.src);
      return $img;
    }

    // TODO: Documentation
    Personalizer.prototype.replaceBackground = function(options) {
      var $bgImg, $bgContainer, backgroundImage;
      backgroundImage = options.backgroundImage;
      $bgContainer = this.backgroundContainer;
      $bgContainer.data('backgroundImage', backgroundImage);
      $bgImg = $bgContainer.find('img');
      $bgImg.attr('src', backgroundImage.toString());
      return $bgImg;
    }

    // Gets dimensions and padding relative to current width of personalizer letters.
    // Both measurements returned as strings ready for img src and wrapper css, respectively.
    // @return [Object]
    Personalizer.prototype.getMeasurements = function() {
      var lettersWidth;
      lettersWidth = $('#personalizer_letters').width();
      return {
        dimensions: '_' + this.letterSize.calcProportionalDimension(lettersWidth) + 'x',
        padding: '0 ' + this.letterSize.calcProportionalPadding(lettersWidth) + 'px',
        spaceWidth: this.letterSize.calcSpaceWidth(lettersWidth) + 'px'
      }
    }

    Personalizer.prototype.insertSpinner = function() {
      this.removeSpinner();
      $('<span class="spinner"><i class="fa fa-3x fa-spinner fa-spin"></i> </span>')
        .prependTo(this.lettersContainer);
    }

    Personalizer.prototype.removeSpinner = function() {
      this.lettersContainer.find('.spinner').remove();
    }

    return Personalizer
  })();


  /*
    global
    cdnFileUrl
  */
  /* eslint-disable-next-line */
  LetterImage = (function() {

    function LetterImage(options) {
      this.theme    = options.theme;
      this.letter   = options.letter;
      this.number   = options.number;
      if (newNamingConvention && this.number < 10) {
        this.number_prefix = 0;
      } else {
        this.number_prefix = "";
      }
      this.prefix   = this.theme + '_' + this.letter;
      this.basename = this.prefix + '_' + this.number_prefix + this.number;
      this.dotext   = '.jpg';
      this.filename = this.basename + this.dotext;
      this.setSrc();
    }

    // Build html string to insert onto the page to render the letter image.
    // @return [String] img html tag wrapped in a span.letter_image
    LetterImage.prototype.buildHtml = function() {
      if (this.letter === 'SPACE') {
        return '<span class="letter_image empty"></span>';
      }
      return '<span class="letter_image"><img src="' + this.src + '" alt="' + this.letter + '"></span>'
    }

    // @param dimensions [String] inserted after file basename to resize image server-side,
    //                            e.g. '_100x' - see Shopify help docs for valid values.
    // @return [String] full url for img src attribute.
    LetterImage.prototype.buildSrc = function(dimensions) {
      dimensions = dimensions || '';
      return cdnFileUrl(this.basename + dimensions + this.dotext);
    }

    LetterImage.prototype.setSrc = function(dimensions) {
      return this.src = this.buildSrc(dimensions);
    }

    LetterImage.prototype.toString = function() {
      return this.src;
    }

    // Clones this instance of LetterImage.
    // @return [LetterImage]
    LetterImage.prototype.clone = function() {
      return new LetterImage(this.getOptions());
    }

    // Gets an options object that can be used to create a similar instance of LetterImage.
    // @return [Object]
    LetterImage.prototype.getOptions = function() {
      return {
        theme:  this.theme,
        letter: this.letter,
        number: this.number
      }
    }

    return LetterImage
  })();


  /* eslint-disable-next-line  */
  LetterSize = (function() {

    // @param options [Object] charLength: [Number] number of characters in customization.
    function LetterSize(options) {
      this.charLength = options.charLength;
      this.dimensions = LetterSize.fullSizes[options.charLength];
      this.width      = this.dimensions.pixels[0];
      this.height     = this.dimensions.pixels[1];
      this.ratioToBg  = this.width / LetterSize.bgSize.pixels[0];
    }

    // Calculate proportional dimension of letter image based on ratio to background.
    // To calculate proportional width, supply width of background image on page. Same for height.
    //
    // @param bgDimension [Number] width or height of background image on page.
    // @return [Number] proportional width or height in pixels.
    LetterSize.prototype.calcProportionalDimension = function(bgDimension) {
      return Math.round(this.ratioToBg * bgDimension)
    }

    // Calculate padding between letters based on ratio to background.
    // Converts from inches to pixels first.
    //
    // @param bgWidth [Number] width background image on page.
    // @return [Number] rounded padding width in pixels (half of gap width).
    LetterSize.prototype.calcProportionalPadding = function(bgWidth) {
      var gapRatio;
      gapRatio = LetterSize.gapWidths[this.charLength] / this.dimensions.inches[0];
      return Math.round(this.ratioToBg * bgWidth * gapRatio / 2);
    }

    // Calculate the width of a space character
    // will be 1/3 of the width of a letter or heart
    //
    // @param bgDimension - width of background image on page.
    // @return [Number] rounded width in pixels
    LetterSize.prototype.calcSpaceWidth = function(bgDimension) {
      return Math.round(this.calcProportionalDimension(bgDimension) / 3);
    }

    // Real size of background image for personalized print.
    LetterSize.bgSize = {
      inches: [30.02, 11.02],
      pixels: [6004, 2204]
    }

    // Full letter sizes in inches and pixels per number of characters.
    // Note sizes 4-5, 7-8, 10-11 are the same.
    LetterSize.fullSizes = (function() {
      var sizes = {
        3: { inches: [6, 8], pixels: [1200, 1600] },
        4: { inches: [4.5, 6], pixels: [900, 1200] },
        6: { inches: [3.5, 4.665], pixels: [700, 933] },
        7: { inches: [3, 4], pixels: [600, 800] },
        9: { inches: [2.625, 3.505], pixels: [525, 701] },
        10: { inches: [2.25, 3], pixels: [450, 600] }
      };
      sizes[5] = sizes[4];
      sizes[8] = sizes[7];
      sizes[11] = sizes[10];
      return sizes;
    })();

    // Width in inches of gaps between letters per number of characters.
    LetterSize.gapWidths = {
      3: 1.375,
      4: 1,
      5: 0.75,
      6: 0.82,
      7: 0.625,
      8: 0.38,
      9: 0.245,
      10: 0.25,
      11: 0.19
    }

    return LetterSize
  })();


  /*
    global
    imagesRetriever
    json_product
    productTheme
  */
  /* eslint-disable-next-line  */
  LetterPicker = (function() {
    var $picker, $lettersContainer, init, activatePicker, toggleTheme, pickLetterImage, close,
        _populatePicker, _insertLoadedLetterImage, _insertPickerSpinner, _removePickerSpinner,
        _togglePickerFilter, _pickerImageInsertionPoint;

    init = function(options) {
      $picker           = $(options.picker);
      $lettersContainer = $(options.lettersContainer);
    }

    activatePicker = function() {
      var activeLetterImage = $(this).data('letterImage');
      $(this).addClass('active').siblings('.letter_image').removeClass('active');
      $picker.find('.letter_image').remove();
      _togglePickerFilter(false);
      $lettersContainer.data({
        activeIndex: $(this).data('index'),
        activeLetterImage: activeLetterImage
      });
      $picker.fadeIn();
      _populatePicker(activeLetterImage, productTheme);
      return false;
    }

    toggleTheme = function() {
      var viewAll, activeLetterImage, theme;
      viewAll = !$picker.data('viewAll');
      _togglePickerFilter(viewAll);
      $picker.find('.letter_image').remove();
      activeLetterImage = $lettersContainer.data('activeLetterImage');
      theme = viewAll ? null : productTheme;
      _populatePicker(activeLetterImage, theme)
      return false;
    }

    pickLetterImage = function(personalizer) {
      var $pickerImage, $img;
      $pickerImage = $(this);
      $pickerImage.addClass('active').siblings('.letter_image').removeClass('active');
      $img = personalizer.replaceImage({
        index: $lettersContainer.data('activeIndex'),
        letterImage: $pickerImage.data('letterImage')
      });
      if (!$img[0].complete) {
        personalizer.insertSpinner();
        $img.on('load', function() { personalizer.removeSpinner() });
      }
      personalizer.createLineItemProperties();
      return false;
    }

    close = function() {
      $lettersContainer.find('.letter_image').removeClass('active');
      $picker.slideUp(200);
      return false;
    }

    _togglePickerFilter = function(viewAll) {
      viewAll = !!viewAll;
      $picker.find('.toggle_theme>a')
        .html(viewAll ? 'View ' + $(json_product.title.split(" ")).not(["Name", "Art", "Letters", "Letter", "Print", "Color"]).get().join(" ") + ' Only' : 'View All');
      $picker.data('viewAll', viewAll);
    }

    _populatePicker = function(activeLetterImage, theme) {
      _insertPickerSpinner();
      imagesRetriever.retrieveImages('letter', {
        letter: activeLetterImage.letter,
        theme: theme,
        callback: function(letterImage) {
          if (letterImage) {
            var $pickerImage = _insertLoadedLetterImage(letterImage);
            if (letterImage.basename === activeLetterImage.basename) {
              $pickerImage.addClass('active');
            }
          }
        }
      })
      // When images retrieval is done or failed.
      .always(_removePickerSpinner);
    }

    _insertLoadedLetterImage = function(letterImage) {
      var marker = _pickerImageInsertionPoint(letterImage);
      return $(letterImage.buildHtml())
        .insertBefore(marker)
        .data('letterImage', letterImage);
    }

    // Determine element before which to insert letter image in picker.
    // Compares image basenames and marks first letter image with higher basename to keep
    // alphabetical sort order.
    // Default insertion point is instructions element (when picker is empty).
    // @return [jQuery,HTMLElement]
    _pickerImageInsertionPoint = function(letterImage) {
      var insertionPoint = $picker.find('.instructions');
      $picker.find('.letter_image').each(function() {
        var thisLetterImage = $(this).data('letterImage');
        if (thisLetterImage && thisLetterImage.basename > letterImage.basename) {
          insertionPoint = this;
          return false;
        }
      });
      return insertionPoint;
    }

    _insertPickerSpinner = function() {
      // prevent multiple spinners from being visible;
      _removePickerSpinner();
      $('<div class="spinner"><i class="fa fa-2x fa-spinner fa-spin"></i> LOADING...</div>')
        .prependTo($picker);
    }

    _removePickerSpinner = function() {
      $picker.find('.spinner').remove();
    }

    // Module's public interface
    return {
      init: init,
      activatePicker: activatePicker,
      close: close,
      pickLetterImage: pickLetterImage,
      toggleTheme: toggleTheme
    }
  })();


  /*
    global
    cdnFileUrl
  */
  /* eslint-disable-next-line */
  BackgroundImage = (function() {

    function BackgroundImage(options) {
      this.theme = options.theme;
      this.number = options.number;
      this.basename = this.theme + '_BG';
      if (this.number) {
        if (this.number < 10 && newNamingConvention) {
          this.basename += '_' + "0" + this.number;
        } else {
          this.basename += '_' + this.number;
        }
      } else if (newNamingConvention) {
        this.basename += '_' + "01";
      }
      this.prefix = this.basename;
      this.dotext = '.jpg';
      this.size = '1000x';
      this.filename = this.basename + this.dotext;
      this.setSrc();
    }

    BackgroundImage.prototype.buildHtml = function() {
      return '<span class="background_image"><img src="' + this.src + '" alt=""></span>'
    }

    BackgroundImage.prototype.buildSrc = function() {
      return cdnFileUrl(this.basename + '_' + this.size + this.dotext);
    }

    BackgroundImage.prototype.setSrc = function() {
      return this.src = this.buildSrc();
    }

    BackgroundImage.prototype.toString = function() {
      return this.src;
    }

    // Clones this instance of BackgroundImage.
    // @return [BackgroundImage]
    BackgroundImage.prototype.clone = function() {
      return new BackgroundImage(this.getOptions());
    }

    // Gets an options object that can be used to create a similar instance of BackgroundImage.
    // @return [Object]
    BackgroundImage.prototype.getOptions = function() {
      return {
        theme:  this.theme,
        number: this.number
      }
    }

    return BackgroundImage
  })();


  /*
    global
    imagesRetriever
    json_product
    productTheme
  */
  /* eslint-disable-next-line */
  BackgroundPicker = (function() {
    var $picker, $backgroundContainer, init, activatePicker, toggleTheme, pickBackground, close,
        _populatePicker, _insertPickerSpinner, _removePickerSpinner,
        _togglePickerFilter, _pickerImageInsertionPoint, _insertLoadedBackgroundImage;

    init = function(options) {
      $picker = $(options.picker);
      $backgroundContainer = $(options.container);
    }

    activatePicker = function() {
      _togglePickerFilter(false);
      $picker.find('.background_image').remove();
      $picker.fadeIn();
      _populatePicker(productTheme);
      return false;
    }

    toggleTheme = function() {
      var viewAll, theme;
      viewAll = !$picker.data('viewAll');
      _togglePickerFilter(viewAll);
      $picker.find('.background_image').remove();
      theme = viewAll ? null : productTheme;
      _populatePicker(theme)
      return false;
    }

    pickBackground = function(personalizer) {
      var $pickerImage, $img;
      $pickerImage = $(this);
      $pickerImage.addClass('active').siblings('.background_image').removeClass('active');
      $img = personalizer.replaceBackground({
        backgroundImage: $pickerImage.data('backgroundImage')
      });
      if (!$img[0].complete) {
        personalizer.insertSpinner();
        $img.on('load', function() { personalizer.removeSpinner() });
      }
      personalizer.createLineItemProperties();
      return false;
    }

    close = function() {
      $picker.slideUp(200);
      return false;
    }

    _togglePickerFilter = function(viewAll) {
      viewAll = !!viewAll;
      $picker.find('.toggle_theme>a')
        .html(viewAll ? 'View ' + $(json_product.title.split(" ")).not(["Name", "Art", "Letters", "Letter", "Print", "Color"]).get().join(" ") + ' Only' : 'View All');
      $picker.data('viewAll', viewAll);
    }

    _populatePicker = function(theme) {
      _insertPickerSpinner();

      var activeBackground = $backgroundContainer.data('backgroundImage');

      imagesRetriever.retrieveImages('background', {
        theme: theme,
        callback: function(backgroundImage) {
          if (backgroundImage) {
            var $pickerImage = _insertLoadedBackgroundImage(backgroundImage);
            if (backgroundImage.basename === activeBackground.basename) {
              $pickerImage.addClass('active');
            }
          }
        }
      })
        .always(_removePickerSpinner);
    }

    _insertLoadedBackgroundImage = function(backgroundImage) {
      var marker = _pickerImageInsertionPoint(backgroundImage);
      return $(backgroundImage.buildHtml())
        .insertBefore(marker)
        .data('backgroundImage', backgroundImage);
    }

    // Determine element before which to insert letter image in picker.
    // Compares image basenames and marks first letter image with higher basename to keep
    // alphabetical sort order.
    // Default insertion point is instructions element (when picker is empty).
    // @return [jQuery,HTMLElement]
    _pickerImageInsertionPoint = function(backgroundImage) {
      var insertionPoint = $picker.find('.instructions');
      $picker.find('.background_image').each(function() {
        var thisBackgroundImage = $(this).data('backgroundImage');
        if (thisBackgroundImage && thisBackgroundImage.basename > backgroundImage.basename) {
          insertionPoint = this;
          return false;
        }
      });
      return insertionPoint;
    }

    _insertPickerSpinner = function() {
      // prevent multiple spinners from being visible;
      _removePickerSpinner();
      $('<div class="spinner"><i class="fa fa-2x fa-spinner fa-spin"></i> LOADING...</div>')
        .prependTo($picker);
    }

    _removePickerSpinner = function() {
      $picker.find('.spinner').remove();
    }

    // Module's public interface
    return {
      init: init,
      activatePicker: activatePicker,
      close: close,
      pickBackground: pickBackground,
      toggleTheme: toggleTheme
    }
  })();


  /*
    global
    Personalizer
    LetterPicker
    BackgroundPicker
    BackgroundImage
    productTheme
  */
  /* eslint-disable-next-line */
  PersonalizerUI = function($form) {
    var personalizer;
    var $personalizer = $('#personalizer');
    var $backgroundContainer = $('#personalizer_bg_img');
    var $lettersContainer = $('#personalizer_letters');
    var $input = $('#personalizer_input');
    var $instructions = $('#personalizer>.instructions');
    var $letterPicker = $('#personalizer_letter_picker');
    var $bgPicker = $('#personalizer_bg_picker');
    var $resetButton = $('#personalizer .reset');
    var $bgPickerToggle = $('.toggle_background');
    var $previewButton = $('#personalizer_preview_btn');
    var $dismissButton = $('#dismiss_only_letters');
    var $dismissMinButton = $('#dismiss_min_letters');
    var containerWidth = $lettersContainer.width();
    var initialBackground = new BackgroundImage({ theme: productTheme });

    LetterPicker.init({
      picker: $letterPicker,
      lettersContainer: $lettersContainer
    });

    BackgroundPicker.init({
      picker: $bgPicker,
      container: $backgroundContainer
    });

    // Set the background image.
    $backgroundContainer.empty()
      .append('<img src="' + initialBackground + '" alt="">')
      .data('backgroundImage', initialBackground);

    $form.on('submit', false);

    $input.on('input change', function() {
      if (Personalizer.containsNumbers(this.value)) {
        $('#only_letters_modal').css('display', 'block');
      }

      if ($input.val().length < 3) {
        $('button.button--add-to-cart').removeClass('ajax-submit');
        $('button.button--add-to-cart').click(function(e) {
          e.preventDefault();
          e.stopPropagation();
          $('#min_letters_modal').css('display', 'block');

          document.querySelector('#min_letters_modal').scrollIntoView({
            behavior: 'smooth',
            block: "end"
          });
        });
      }

      this.value = Personalizer.cleanInput(this.value);
      return false;
    });

    $dismissButton.click(function(event) {
      $('#only_letters_modal').css('display', 'none');
      return false;
    });

    $dismissMinButton.click(function(event) {
      $('#min_letters_modal').css('display', 'none');
      return false;
    });

    // Initialize the personalizer only after text has been entered
    // and the preview button is clicked.
    $previewButton.click(function(event) {
      console.debug('personalize', productTheme, this, event);
      if ($input[0].value === '') {
        $input.focus();
        return false;
      }
      initUI();
      return false;
    });

    $resetButton.click(function() {
      resetUI()
      return false;
    });

    // Will only resize if it's necessary (i.e. the background image has changed sizes)
    // NOTE: This listener has the potential to be fairly expensive;
    $(window).resize(function() {
      // check if photos are being displayed
      if ($lettersContainer.css('display') === 'none') return;
      var newWidth = $lettersContainer.width();
      if (containerWidth !== newWidth) {
        personalizer.overlayLetters($lettersContainer);
        containerWidth = newWidth;
      }
    });

    // Open background picker via button.
    $bgPickerToggle
      .on('click', BackgroundPicker.activatePicker)
      .on('click', LetterPicker.close);

    // Open background picker via direct clicks on background image.
    $personalizer.on('click', function(event) {
      var clickableElements = ['personalizer_bg_img', 'personalizer_controls', 'personalizer_controls_container', 'personalizer_letters'];
      if (personalizer && clickableElements.indexOf(event.target.id) > -1) {
        BackgroundPicker.activatePicker();
        LetterPicker.close();
      }
    });

    // View all background images or only for current theme.
    $bgPicker.find('.toggle_theme > a').on('click', BackgroundPicker.toggleTheme);

    $bgPicker.find('.close > a').on('click', BackgroundPicker.close)

    // Pick background image.
    $bgPicker.on('click', '.background_image', function() {
      return BackgroundPicker.pickBackground.call(this, personalizer);
    });

    // Click on letter to view image options.
    $lettersContainer
      .on('click', '.letter_image', LetterPicker.activatePicker)
      .on('click', '.letter_image', BackgroundPicker.close);

    // View all letter images or only for current theme.
    $letterPicker.find('.toggle_theme > a').on('click', LetterPicker.toggleTheme);

    // Pick personalized letter image.
    $letterPicker.on('click', '.letter_image', function() {
      return LetterPicker.pickLetterImage.call(this, personalizer);
    });

    $letterPicker.find('.close').click(LetterPicker.close);

    /**
     * Sets up the personalizer once a user has submitted text.
     */
    function initUI() {
      personalizer = new Personalizer({
        form: $form[0],
        theme: productTheme,
        string: $input[0].value
      });
      personalizer.createLineItemProperties();
      personalizer.overlayLetters($lettersContainer);
      $instructions.html('Click on any <strong>letter</strong> or the <strong>background image</strong> to choose a specific image');
      $form.off('submit', false);
      $resetButton.show();
      $bgPickerToggle.show();
      enableCheckout();
    }

    /**
     * Resets the UI to it's original state.
     */
    function resetUI() {
      disableCheckout();
      $lettersContainer.hide().empty();
      if (personalizer) {
        personalizer.clearLineItemProperties();
        personalizer = null;
      }
      $form.on('submit', false);
      $letterPicker.hide();
      $bgPicker.hide();
      $('#personalizer_controls').fadeIn();
      $input.val('').focus();
      $instructions.html('Enter your desired text above and click preview to see your print');
      $resetButton.hide();
      $bgPickerToggle.off('click', false).hide();
      $backgroundContainer.empty()
        .append('<img src="' + initialBackground + '" alt="">')
        .data('backgroundImage', initialBackground);
    }
  }


  /**
   * Initializes the whole personalizer.
   */
  init = function() {
    productTheme = findThemePrefix();
    newNamingConvention = findNamingConvention();
    imagesRetriever = new ImagesRetriever();
    if (!productTheme) {
      console.log('Personalizer theme not found for current product.');
      return;
    }
    console.debug('productTheme', productTheme);
    // Bind all UI controls.
    PersonalizerUI($('.personalizer_add_to_cart_form'));
  }

  return {
    themeTags: themeTags,
    init: init
  }
});

// CDN URLs without query strings will break the personalizer,
// so we need to ensure the URL contains at least one query param
// as a fallback in case the actual placeholder image is deleted.
var shopify_file_url = (shopify_cdn_url_template && shopify_cdn_url_template.indexOf('?'))
  ? shopify_cdn_url_template
  : '//cdn.shopify.com/s/files/1/0519/6157/files/placeholder-for-personalizer.jpg?v=14372335844852976482';

if (typeof(json_product) === 'undefined') {
  $.getJSON('https://personal-prints.com/products/' + product_handle + '.json').then(function(data) {
    var json_product = data.product;
    PersonalPrintsPersonalizer(json_product, shopify_theme_tags, shopify_file_url).init();
  });
}
else {
  PersonalPrintsPersonalizer(json_product, shopify_theme_tags, shopify_file_url).init();
}

function disableCheckout() {
  hideShopifyCheckout = true;
  targetNode = document.getElementsByClassName('shopify-product-form')[0];
  observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  $('button.button--add-to-cart').removeClass('ajax-submit');
  $('button.button--add-to-cart').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('#min_letters_modal').css('display', 'block');

    document.querySelector('#min_letters_modal').scrollIntoView({
      behavior: 'smooth',
      block: "end"
    });
  });
}
function enableCheckout() {
  hideShopifyCheckout = false;
  $(".shopify-payment-button").show();
  $('button.button--add-to-cart').addClass('ajax-submit');
  $('button.button--add-to-cart').unbind('click');
}

//setup global scope mutation observers for shopify dynamic button
var hideShopifyCheckout = true;
var targetNode = [];
const config = { attributes: true, childList: true, subtree: true };
var observer = [];
const callback = function(mutationList, observer) {
  for(const mutation of mutationList) {
      if (mutation.type === 'childList') {
        var dynamicShopifyCheckout = document.querySelector(".shopify-payment-button");

        if (dynamicShopifyCheckout && hideShopifyCheckout) {
          $(".shopify-payment-button").hide();
        }
      }
  }
};

//disable checkout until minLetters
$(document).ready(function() {
  disableCheckout();
});